import * as React from "react";
import { cn } from "@/shared/lib/utils";

interface ICookieButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    children: React.ReactNode,
}

const CookieButton = React.forwardRef<HTMLButtonElement, ICookieButtonProps>(
    ({ children, className, ...props }, ref) => {

        return (
            <button
                ref={ref}
                className={cn(
                    "shadow-glass border-[0.5px] border-white-50 !leading-none rounded-full font-manrope text-[16px] transition-all ease-linear duration-200",
                    'px-[8px] text-[8px] h-[30px] rounded-[10px] shadow-xl bg-white shadow-bg hover:bg-light-blue',
                    className
                )}
                {...props}
            >
                {children}
            </button>
        );
    }
);

CookieButton.displayName = "CookieButton";

export default CookieButton;
